import React, {useState, useEffect, useMemo} from 'react';
import {renderToStaticMarkup} from 'react-dom/server'

const setMarkerPosition = (
  {
    container,
    marker,
    targetElement,
    offsetX,
    offsetY,
    centerOnTarget
  }
) => {
  if (container && marker && targetElement) {
    let x = (offsetX || 0)
    let y = (offsetY || 0)

    const targetElementBoundingBox = targetElement.getBBox()

    x += targetElementBoundingBox.x
    y += targetElementBoundingBox.y

    console.log({targetElementBoundingBox, x, y})

    if (centerOnTarget) {
      x += targetElementBoundingBox.width / 2
      y += targetElementBoundingBox.height / 2
    }

    marker.setAttribute("x", x);
    marker.setAttribute("y", y)
    marker.scrollIntoView({
        behavior: 'auto',
        block: 'center',
        inline: 'center'
      });
  }
}

/**
 * Example:
 *   <Marker
 *     targetContainerId={"club-hannelore-svg"}
 *     offsetX={180}
 *     offsetY={200}
 *   >
 *     <rect style={{fill: "#123456"}} width="86.64" height="164.28"></rect>
 *   </Marker>
 */
const Marker = (
  {
    targetContainerId,
    targetContainerQuerySelector,
    targetElementId,
    targetElementQuerySelector,
    offsetX,
    offsetY,
    children,
    centerOnTarget
  }
) => {
  const container = useMemo(() => {
    return document.getElementById(targetContainerId) || document.querySelector(targetContainerQuerySelector)
  }, [targetContainerId, targetContainerQuerySelector, children]) // Without the child element the container is not yet in the dom or something resulting in container being null

  const marker = useMemo(() => {
    const markerHtml = renderToStaticMarkup(children);
    const markerContainer = document.createElementNS("http://www.w3.org/2000/svg", "svg")
    markerContainer.innerHTML = markerHtml
    return [...markerContainer.childNodes].filter(ee => ee.tagName === "svg")[0]
  }, [children])

  const targetElement = useMemo(() => {
    return document.getElementById(targetElementId) || document.querySelector(targetElementQuerySelector)
  }, [targetElementId, children]) // Without the child element the targetElement is not yet in the dom or something resulting in targetElement being null

  useEffect(() => {
    if (container && marker) {
      container.appendChild(marker)
    }

    return () => {
      marker.remove()
    }
  }, [container, marker])

  useEffect(() => {
    const setCurrentMarkerPosition = () => {
      setMarkerPosition(
        {
          container,
          marker,
          targetElement,
          offsetX,
          offsetY,
          centerOnTarget
        }
      )
    }

    setCurrentMarkerPosition()

    window.addEventListener('resize', setCurrentMarkerPosition, true);
    window.addEventListener('redraw-marker', setCurrentMarkerPosition, true);

    return () => {
      window.removeEventListener('resize', setCurrentMarkerPosition)
      window.removeEventListener('redraw-marker', setCurrentMarkerPosition)
    }
  }, [
    container,
    marker,
    targetElement,
    offsetX,
    offsetY,
    centerOnTarget,
  ])

  return null
}

export default Marker